<section class="tickets-toolbar">
  <div class="tickets-filter">
    <label [for]="prefijo + '-periodo'">Periodo</label>
    <div class="tickets-select">
      <mat-icon>date_range</mat-icon>
      <select [id]="prefijo + '-periodo'" [(ngModel)]="periodoSeleccionado" (ngModelChange)="aplicarPeriodo()">
        <option *ngFor="let periodo of periodos" [ngValue]="periodo.id">{{ periodo.nombre }}</option>
      </select>
    </div>
  </div>

  <div class="tickets-filter">
    <label [for]="prefijo + '-inicio'">Inicio</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="tickets-date-field">
      <input [id]="prefijo + '-inicio'" matInput aria-label="Inicio" [matDatepicker]="fechaInicioPicker" [(ngModel)]="fechaInicioSeleccionada"
        (dateChange)="onFechaInicioChange($event.value)" />
      <mat-datepicker-toggle matSuffix [for]="fechaInicioPicker"></mat-datepicker-toggle>
      <mat-datepicker #fechaInicioPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tickets-filter">
    <label [for]="prefijo + '-fin'">Fin</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="tickets-date-field">
      <input [id]="prefijo + '-fin'" matInput aria-label="Fin" [matDatepicker]="fechaFinPicker" [(ngModel)]="fechaFinSeleccionada"
        (dateChange)="onFechaFinChange($event.value)" />
      <mat-datepicker-toggle matSuffix [for]="fechaFinPicker"></mat-datepicker-toggle>
      <mat-datepicker #fechaFinPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <ng-content select="[meta]"></ng-content>
</section>
